import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_class_input = _resolveComponent("ontos-class-input")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ontos_form_dialog = _resolveComponent("ontos-form-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_form_dialog, _mergeProps(_ctx.heading, {
    "max-width": "800px",
    saving: _ctx.saving,
    "save-disabled": _ctx.edit.unchanged,
    dirty: _ctx.edit.dirty,
    "full-page-route": _ctx.fullPageRoute,
    onSave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save())),
    onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closed')))
  }), {
    default: _withCtx(() => [
      _createVNode(_component_v_form, { ref: "form" }, {
        default: _withCtx(() => [
          _createVNode(_component_ontos_class_input, {
            ref: "input",
            value: _ctx.draft,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.draft = $event)),
            ideas: _ctx.workspace.ideas,
            "fixed-alias": !_ctx.isCreating,
            "start-with-auto-alias": _ctx.isCreating,
            "start-with-auto-plural": _ctx.isCreating
          }, null, 8, ["value", "ideas", "fixed-alias", "start-with-auto-alias", "start-with-auto-plural"]),
          (_ctx.isCreating)
            ? (_openBlock(), _createBlock(_component_v_checkbox, {
                key: 0,
                modelValue: _ctx.identifiedByName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.identifiedByName) = $event)),
                "hide-details": "",
                class: "mt-0",
                label: _ctx.$tt('identified-by-name')
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 16, ["saving", "save-disabled", "dirty", "full-page-route"]))
}